import { Tier } from '@/services/Navigation';

function convertFromTier(tier: Tier) {
	// default
	let selection = {
		text: 'All - displayed',
		value: 0
	};
	const hash = tier.type + tier.display;

	switch (hash) {
		case 'alltrue':
			selection = {
				text: 'All - displayed',
				value: 0
			};
			break;
		case 'allfalse':
			selection = {
				text: 'All - hidden',
				value: 3
			};
			break;
		case 'contexttrue':
			selection = {
				text: 'Context - displayed',
				value: 1
			};
			break;
		case 'contextfalse':
			selection = {
				text: 'Context - hidden',
				value: 4
			};
			break;
		case 'parentContexttrue':
			selection = {
				text: 'Selected - displayed',
				value: 2
			};
			break;
		case 'parentContextfalse':
			selection = {
				text: 'Selected - hidden',
				value: 5
			};
			break;
	}

	return selection;
}

function convertToTier(tier: number) {
	// default
	let selection = {
		type: 'all',
		display: true
	};

	switch (tier) {
		case 0:
			selection = {
				type: 'all',
				display: true
			};
			break;
		case 3:
			selection = {
				type: 'all',
				display: false
			};
			break;
		case 1:
			selection = {
				type: 'context',
				display: true
			};
			break;
		case 4:
			selection = {
				type: 'context',
				display: false
			};
			break;
		case 2:
			selection = {
				type: 'parentContext',
				display: true
			};
			break;
		case 5:
			selection = {
				type: 'parentContext',
				display: false
			};
			break;
	}

	return selection;
}

const tierOptions = [
	{
		text: 'All - displayed',
		value: 0
	},
	{
		text: 'Context - displayed',
		value: 1
	},
	{
		text: 'Selected - displayed',
		value: 2
	},
	{
		text: 'All - hidden',
		value: 3
	},
	{
		text: 'Context - hidden',
		value: 4
	},
	{
		text: 'Selected - hidden',
		value: 5
	},
];

export { convertFromTier, convertToTier, tierOptions };